import adminApi from "./adminApi";

export async function getPredictionPresets() {
  const { data } = await adminApi.get("/psettings/presets");
  return data.presets;
}

export async function getPreset(id) {
  const { data } = await adminApi.get(`/psettings/${id}`);
  return data;
}

export async function createPreset({
  name,
  description,
  copyFromPresetId = null,
}) {
  const { data } = await adminApi.post("/psettings", {
    name,
    description,
    copyFromPresetId,
  });

  return data;
}

export async function updatePresetSettings(id, settings) {
  const { data } = await adminApi.put(
    `/psettings/${id}`,
    settings
  );

  return data;
}

export async function activatePreset(id) {
  const { data } = await adminApi.post(
    `/psettings/${id}/activate`
  );

  return data;
}

export async function deletePreset(id) {
  const { data } = await adminApi.delete(
    `/psettings/${id}`
  );

  return data;
}

export async function duplicatePreset(
  id,
  name,
  description = ""
) {
  return createPreset({
    name,
    description,
    copyFromPresetId: id,
  });
}